import * as React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Switch, Route as StdRoute, Redirect, withRouter} from 'react-router-dom';
import Login from './screens/Login';
import Cases from './screens/cases/Cases';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/index.css';
import './css/questions.css';
import './css/theme.css';
import Courses from './screens/courses/Courses';
import { AppRoute } from './definitions/routes';
import ScenarioCourse from './screens/courses/ScenarioCourse';
import Auth from './services/Auth';
import GroupTesting from './screens/group-testing/GroupTesting';
import { Alert } from 'react-bootstrap';

/*Вот так решается с роутами*/
class Route extends StdRoute {};

interface IAppProps {
    
}

interface IAppState {
  initSession: boolean,
  isLoggedIn?: boolean,
  error?: string,
  redirectOnLogin: boolean
}

class App extends React.PureComponent<IAppProps, IAppState> {
  
  constructor(props: IAppProps)
  {
    super(props);

    this.state = {
      initSession: true,
      isLoggedIn: false,
      error: undefined,
      redirectOnLogin: false
    }

    Auth.onLogout(() => this.setState({isLoggedIn: false}));
  }
  
  async componentDidMount() {

    var url = new URL(window.location.href);
    var sessionKey = url.searchParams.get("sessionKey");
    let isLoggedIn;
    let error;
    try {
      isLoggedIn = await Auth.initSession(sessionKey || undefined);
    } catch(err) {
      error = err.error ? err.error : "Unknown error";
      console.log(err);
    }
    this.setState({
      initSession: false,
      isLoggedIn,
      error
    });      
  }

  public render() {

    const { isLoggedIn } = this.state;
    const centeredStyle = {display: "flex", alignItems: "center", justifyContent: "center", height: "100%"};

    return (
      this.state.error ? 
      <div style={centeredStyle}>
        <Alert variant={'danger'} >
          {this.state.error}
        </Alert>
        </div>
      : this.state.initSession ?
        <h1 className="login-form-header" style={centeredStyle}>Загрузка...</h1>
      : !isLoggedIn ?
        <Login onLoggedIn={ () => {
          this.setState({
            isLoggedIn: true,
            redirectOnLogin: true
          });
        }}/>
      :
      <Router>        
          <Switch>
            { this.state.redirectOnLogin && false /*не доделано*/? <Redirect to="/courses" /> :
            <Switch>
              <Route path='/' exact>
                <Redirect to="/courses" />
              </Route>
              <Route path='/assignment/:id'><span>Hello!</span></Route>
              <Route path={AppRoute.COURSES}><Courses /></Route>
              <Route path={`${AppRoute.SCENARIO_COURSE}/:courseUserAssignment`}><ScenarioCourse /></Route>
              <Route path={`${AppRoute.CASES}/:courseUserAssignmentId`} render={props => <Cases assignmentId={props.match.params.courseUserAssignmentId} />} />
              <Route path={`${AppRoute.GROUP_TESTING}/:courseUserAssignmentId`} render={props => <GroupTesting assignmentId={props.match.params.courseUserAssignmentId} />} />             
            </Switch>
          }
          </Switch>
      </Router>
    );
  }
};

export default App;
